import Clarity from '@microsoft/clarity';
import { useCallback } from 'react';

type SendClarityEvent = (eventName: string) => void;

/**
 * Sends a Microsoft Clarity custom event, swallowing any failure — Clarity may not be initialized
 * yet (or at all, e.g. outside the embedded app) and a tracking call should never break the feature
 * it's attached to.
 */
const useSendClarityEvent = (): SendClarityEvent =>
    useCallback((eventName: string) => {
        try {
            Clarity?.event(eventName);
        } catch (error) {}
    }, []);

export default useSendClarityEvent;
